export const actions = {
  set_state: 'users/set_state',
  get_users: 'users/get_users',
  update_users: 'users/update_users',
  add_credit: 'users/add_credit',
  delete_users: 'users/delete_users',
  create_users: 'users/create_users'
}
